// extracted by mini-css-extract-plugin
module.exports = {"outer":"XxnxP","heading":"RGmM_","stepsWrapper":"_2QDfT","leftWrapper":"_2ALEK","rightWrapper":"-o83d","stepsDetail":"_24sLF","count":"_3x6Wb"};